/** AccountServices - add some comment */

export const accountServices = {
    findFinancialAccounts,
    insertFinancialAccounts,
    findNewAccountNumber,
    findAccount,
    findAccountById,
    insertNewSubAccount,
    insertUpdatedAccount,
    removeDeletedAccount,
    removeChildrenProperty,
    insertCustomUpdatedAccount,
    removeDeletedCustomAccount,
    isPinnedWithAutoAddChildren,
    insertUpdatedAccountIntoCustomAccount,
    insertParentIntoFinancialAccounts,
};

function findFinancialAccounts(ftype, accountStructure) {
    let result;

    switch (ftype) {
        case 'BSA':
            result = accountStructure.balancesheet.assets;
            break;

        case 'BSL':
            result = accountStructure.balancesheet.liabilities;
            break;

        case 'BSE':
            result = accountStructure.balancesheet.equities;
            break;

        case 'PL':
            result = accountStructure.profitloss;
            break;

        case 'CF':
            result = accountStructure.cashflow;
            break;

        case 'CUSTOM':
            result = accountStructure.custom;
            break;

        default:
            result = accountStructure.drivers;
            break;
    }
    return result;
}

function insertFinancialAccounts(ftype, newFinancialAccounts, newAccountStructure) {
    switch (ftype) {
        case 'BSA':
            newAccountStructure.balancesheet.assets = newFinancialAccounts;
            break;

        case 'BSL':
            newAccountStructure.balancesheet.liabilities = newFinancialAccounts;
            break;

        case 'BSE':
            newAccountStructure.balancesheet.equities = newFinancialAccounts;
            break;

        case 'PL':
            newAccountStructure.profitloss = newFinancialAccounts;
            break;

        case 'CF':
            newAccountStructure.cashflow = newFinancialAccounts;
            break;

        case 'CUSTOM':
            newAccountStructure.custom = newFinancialAccounts;
            break;

        default:
            newAccountStructure.drivers = newFinancialAccounts;
            break;
    }
    return newAccountStructure;
}

function findNewAccountNumber(accountStructure) {
  const allAccounts = [];
  findAllAccounts(allAccounts, accountStructure);

  const re = /_(\d+)/;

  const prevAccNum = allAccounts
    .map((account) => {
      if (!account || typeof account.account_number !== "string") return null;
      const match = re.exec(account.account_number);
      return match ? Number(match[1]) : null;
    })
    .filter((n) => n !== null)
    .sort((a, b) => a - b)
    .pop();

  return prevAccNum === undefined ? "Account_0" : `Account_${prevAccNum + 1}`;
}

function findAccount(accountCopy, accountID, accounts) {
    if (Array.isArray(accounts)) {
        accounts.forEach((account) => {
            if (account.associated_account_id == null && account.account_id === accountID) {
                accountCopy['copy'] = account;
            } else if (account.associated_account_id != null && account.associated_account_id === accountID) {
                accountCopy['copy'] = account;
            }
            if (account.children) {
                findAccount(accountCopy, accountID, account.children);
            }
        });
    } else {
        for (const key in accounts) {
            findAccount(accountCopy, accountID, accounts[key]);
        }
    }
}

function findAccountById(accountID, accounts) {
    for (const account of accounts) {
        if (account.account_id === accountID) return account;

        if (account.children) {
            let accountChild = findAccountById(accountID, account.children);

            if (accountChild) return accountChild;
        }
    }
}

function findAllAccounts(allAccounts, accounts) {
  if (!accounts) return;

  if (Array.isArray(accounts)) {
    accounts.forEach((account) => {
      if (!account || typeof account !== "object") return; // ✅ guard

      allAccounts.push(account);

      if (account.children) {
        findAllAccounts(allAccounts, account.children);
      }
    });
  } else {
    if (typeof accounts !== "object") return; 

    for (const key in accounts) {
      const value = accounts[key];
      if (!value || typeof value !== "object") continue; 

      if (value.account_id !== undefined) {
        allAccounts.push(value);
      }

      findAllAccounts(allAccounts, value);
    }
  }
}

function insertNewSubAccount(newAccount, accounts) {
    if (Array.isArray(accounts)) {
        accounts.forEach((account) => {
            if (account.account_id === newAccount.parent) {
                if (account.children !== undefined) {
                    account.children.push(newAccount);
                    return;
                } else {
                    account['children'] = [newAccount];
                    return;
                }
            }
            if (account.children !== undefined) {
                insertNewSubAccount(newAccount, account.children);
            }
        });
    } else {
        for (const key in accounts) {
            if (accounts[key].account_id === newAccount.parent) {
                accounts[key]['children'] = [newAccount];
                return;
            }
            insertNewSubAccount(newAccount, accounts[key]);
        }
    }
}

function removeDeletedAccount(deletedAccount, accounts) {
    if (Array.isArray(accounts)) {
        for (let i = 0; i < accounts.length; i++) {
            if (accounts[i].account_id === deletedAccount.account_id) {
                accounts.splice(i, 1);
                return;
            }
            if (accounts[i].children !== undefined) {
                removeDeletedAccount(deletedAccount, accounts[i].children);
            }
        }
    } else {
        for (const key in accounts) {
            if (accounts[key].account_id === deletedAccount.account_id) {
                delete accounts[key];
                return;
            }
            removeDeletedAccount(deletedAccount, accounts[key]);
        }
    }
}

function removeChildrenProperty(parentId, accounts) {
    if (Array.isArray(accounts)) {
        for (let i = 0; i < accounts.length; i++) {
            if (accounts[i].account_id === parentId) {
                if (accounts[i].children.length === 0) {
                    delete accounts[i].children;
                }
                return;
            }
            if (accounts[i].children !== undefined) {
                removeChildrenProperty(parentId, accounts[i].children);
            }
        }
    } else {
        for (const key in accounts) {
            if (accounts[key].account_id === parentId) {
                delete accounts[key];
                return;
            }
            removeChildrenProperty(parentId, accounts[key]);
        }
    }
}

function insertUpdatedAccount(updatedAccount, accounts) {
    if (Array.isArray(accounts)) {
        for (let i = 0; i < accounts.length; i++) {
            if (accounts[i].account_id === updatedAccount.account_id) {
                if (accounts[i].children !== undefined) {
                    updatedAccount['children'] = [...accounts[i].children];
                }
                accounts[i] = updatedAccount;
                return;
            }
            if (accounts[i].children !== undefined) {
                insertUpdatedAccount(updatedAccount, accounts[i].children);
            }
        }
    } else {
        for (const key in accounts) {
            if (accounts[key].account_id === updatedAccount.account_id) {
                accounts[key] = updatedAccount;
                return;
            }
            insertUpdatedAccount(updatedAccount, accounts[key]);
        }
    }
}

function insertCustomUpdatedAccount(customUpdatedAccount, accounts) {
    if (Array.isArray(accounts)) {
        for (let i = 0; i < accounts.length; i++) {
            if (accounts[i].account_id === customUpdatedAccount.account_id) {
                accounts[i] = customUpdatedAccount;
                return;
            }
            if (accounts[i].children !== undefined) {
                insertUpdatedAccount(customUpdatedAccount, accounts[i].children);
            }
        }
    } else {
        for (const key in accounts) {
            if (accounts[key].account_id === customUpdatedAccount.account_id) {
                accounts[key] = customUpdatedAccount;
                return;
            }
            insertCustomUpdatedAccount(customUpdatedAccount, accounts[key]);
        }
    }
}

function removeDeletedCustomAccount(deletedAccount, accounts) {
    if (Array.isArray(accounts)) {
        for (let i = 0; i < accounts.length; i++) {
            if (accounts[i].account_id === deletedAccount.account_id) {
                accounts.splice(i, 1);
                return;
            }
            if (accounts[i].children !== undefined) {
                removeDeletedCustomAccount(deletedAccount, accounts[i].children);
            }
            if (accounts[i].custom_tab_accounts) {
                removeDeletedCustomAccount(deletedAccount, accounts[i].custom_tab_accounts);
            }
        }
    } else {
        for (const key in accounts) {
            if (accounts[key].account_id === deletedAccount.account_id) {
                delete accounts[key];
                return;
            }
            removeDeletedCustomAccount(deletedAccount, accounts[key]);
        }
    }
}

/**
 * True when accountId is pinned anywhere in the custom-tab rows with
 * "Add new sub-accounts automatically" switched on.
 */
function isPinnedWithAutoAddChildren(accountId, rows) {
    return (rows ?? []).some(
        (row) =>
            (row.account_id === accountId && row.auto_add_children === true) ||
            isPinnedWithAutoAddChildren(accountId, row.children),
    );
}

function insertUpdatedAccountIntoCustomAccount(updatedAccount, accounts) {
    if (Array.isArray(accounts)) {
        for (let i = 0; i < accounts.length; i++) {
            if (accounts[i].account_id === updatedAccount.account_id) {
                accounts[i]['customAccount'] = updatedAccount;
            }
            if (accounts[i].children !== undefined) {
                insertUpdatedAccountIntoCustomAccount(updatedAccount, accounts[i].children);
            }
        }
    } else {
        for (const key in accounts) {
            if (accounts[key].account_id === updatedAccount.parent) {
                accounts[key]['customAccount'] = updatedAccount;
            }
            insertUpdatedAccountIntoCustomAccount(updatedAccount, accounts[key]);
        }
    }
}

function insertParentIntoFinancialAccounts(parentAccount, financialAccounts) {
    for (let i = 0; i < financialAccounts.length; i++) {
        if (financialAccounts[i].account_id === parentAccount.account_id) {
            financialAccounts[i] = parentAccount;
        }
        if (financialAccounts[i].children !== undefined) {
            insertParentIntoFinancialAccounts(parentAccount, financialAccounts[i].children);
        }
    }
}
